import {ROLES} from "../../../settings";

export enum UsersInviteTypes {
    Email= 'email',
    FirstName = 'first_name',
    LastName = 'last_name',
    Role = 'role',
    StatesOfBusiness = 'states_of_business',
    CompanyName = 'company_name',
    DunsNumber = 'duns_number',
    NaicsCodes = 'naics_codes',
    PscCodes = 'psc_codes',
    Keywords = 'keywords',
    AllowAlertEmails = 'allow_alert_emails',
    Active = 'active',
    AccountStatus = 'account_status'
}

export const ALLOWED_ROLES_BY_ROLE = {
    [ROLES.ADMIN]: Object.values(ROLES),
    [ROLES.SALES]: [ROLES.CLIENT],
}